/**
 * Helpers for numeric form inputs.
 *
 * A native `<input type="number">` still lets users type `e`, `E`, `+`, `-`, and
 * `.` (and paste arbitrary text), so a "numbers only" field can end up holding
 * `"e"` or `"1e3"`. Using `type="text" inputMode="numeric"` + this sanitizer
 * guarantees the stored value is digits only, while keeping the mobile numeric
 * keypad.
 */

/** Strip everything except digits — yields a non-negative integer string (or ''). */
export function sanitizeInteger(value: string): string {
  return (value ?? '').replace(/[^0-9]/g, '');
}
